/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/


export default {
  ADD_ITEM (state, user) {
    state.companies.push(Object.assign({}, user))
  },
  SET_TRAINEE_COACH (state, traineeCoach) {
    state.traineeCoach = traineeCoach
  },

  REMOVE_RECORD (state, itemId) {
    const traineeCoachIndex = state.traineeCoach.findIndex((u) => u.id === itemId)
    state.traineeCoach.splice(traineeCoachIndex, 1)
  },


  SET_ALL_TRAINEES (state, data) {
    state.traineeList = data
  },
  SET_SIDEBAR_ID (state, id) {
    state.sidebarId = id
  }
}
